import { render } from "./Unregister.vue?vue&type=template&id=b984a36c"
import script from "./Unregister.vue?vue&type=script&lang=js"
export * from "./Unregister.vue?vue&type=script&lang=js"

import "./Unregister.vue?vue&type=style&index=0&id=b984a36c&lang=css"
script.render = render

export default script